import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ToastProvider from 'services/toast/ToastProvider';

import ApiStatusProvider from 'hooks/ApiStatus';

import MainLayout from 'layout/mainLayout';

import GlobalStyle from 'styles/globalStyle';
import ThemeProvider from 'styles/ThemeProvider';
import GridTheme from 'styles/GridTheme';

import routes from './routes';

const App = () => {
  const { t } = useTranslation();

  const defaultRoute = t('routes.importerPage');

  return (
    <Router>
      <ThemeProvider>
        <GridTheme>
          <ToastProvider />
          <GlobalStyle />
          <ApiStatusProvider>
            <MainLayout routes={routes}>
              <Switch>
                {routes.map(({ path, pageComponent }) => (
                  path && <Route key={`route-${path}`} path={path} component={pageComponent} />
                ))}
                <Redirect to={defaultRoute} />
              </Switch>
            </MainLayout>
          </ApiStatusProvider>
        </GridTheme>
      </ThemeProvider>
    </Router>
  );
};

export default App;
